/* eslint-disable */
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue';
require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('logo-generator', require('./components/LogoGenerator.vue').default);
Vue.component('download-logo', require('./components/DownloadLogo.vue').default);

new Vue({
  el: '#app'
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js